import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import TextField from '@mui/material/TextField'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Dialog from 'components/Dialog'
import ColorPicker from 'components/ColorPicker'

const Label = styled.div`
    color: rgba(0, 0, 0, 0.54);
    font-size: 12px;
    margin-bottom: 10px;
`

const Field = styled(TextField)`
    width: 100%;
    margin-bottom: 20px;
`

const Color = styled.div`
    width: 100%;
`

const types = ['custom', 'field']
const mark = '@'

class ButtonDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            name: props.data ? props.data.name : '',
            url: props.data ? props.data.url : '',
            background: props.data ? props.data.background : '#415DD4',
            color: props.data ? props.data.color : '#FFF',
            type: props.data && props.data.url.slice(0, 1) === mark ? types[1] : types[0]
        }
    }

    handleChange = (e) => {
        if (e.target.name === 'type') {
            this.setState({
                type: e.target.value,
                url: e.target.value === types[0] ? '' : mark + this.props.options[0].name
            })
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }
    }

    onChangeBackground = (color) => {
        this.setState({
            background: color.hex
        })
    }

    onChangeColor = (color) => {
        this.setState({
            color: color.hex
        })
    }

    handleDelete = () => {
        this.props.handleEditorUpdate(this.props.id)
        this.props.handleClose()
    }

    handleEdit = () => {
        const obj = {
            name: this.state.name,
            url: this.state.url,
            background: this.state.background,
            color: this.state.color,
            type: this.state.type
        }

        if (this.props.data) {
            this.props.handleEditorUpdate(this.props.id, obj)
        } else {
            this.props.insertBlock(this.props.type, obj)
        }

        this.props.handleClose()
    }

    render() {
        const {intl} = this.props
        const invalid = !this.state.name || !this.state.url || (this.state.url.slice(0, 1) === mark && this.state.type === types[0])

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.button_settings"})}
                </DialogTitle>
                <DialogContent>
                    <Field
						variant="standard"
                        value={this.state.name}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.button_label"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH,
                            name: 'name'
                        }}
                    />
                    {!!this.props.options.length &&
                        <FormControl style={{width: '100%', marginBottom: '20px'}} variant="standard">
                            <InputLabel>
                                {intl.formatMessage({id: "editor.url_type"})}
                            </InputLabel>
                            <Select
                                value={this.state.type}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'type'
                                }}
                            >
                                {types.map(item =>
                                    <MenuItem key={item} value={item}>
                                        {intl.formatMessage({id: `editor.url_${item}`})}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {this.state.type === types[0] ?
                        <Field
							variant="standard"
                            defaultValue={this.state.url}
                            onChange={this.handleChange}
                            label={intl.formatMessage({id: "editor.url"})}
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                name: 'url'
                            }}
                        />
                        :
                        <FormControl style={{width: '100%', marginBottom: '20px'}} variant="standard">
                            <InputLabel>
                                {intl.formatMessage({id: "editor.url"})}
                            </InputLabel>
                            <Select
                                value={this.state.url}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'url'
                                }}
                            >
                                {this.props.options.map(item =>
                                    <MenuItem key={item.id} value={mark + item.name}>
                                        {item.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    <div style={{display: 'flex'}}>
                        <Color>
                            <Label>{intl.formatMessage({id: "editor.background_color"})}</Label>
                            <ColorPicker
                                color={this.state.background}
                                handleChange={this.onChangeBackground}
                                type='square'
                            />
                        </Color>
                        <Color>
                            <Label>{intl.formatMessage({id: "editor.text_color"})}</Label>
                            <ColorPicker
                                color={this.state.color}
                                handleChange={this.onChangeColor}
                                type='square'
                            />
                        </Color>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleEdit}
                        disabled={invalid}
                        variant="contained"
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(ButtonDialog)
